import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../pages/users/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private _authService: AuthService, private _toastr: ToastrService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            var errorMsg = "";
            switch (err.status) {
                case 401:
                    setTimeout(() => {
                        this._toastr.error('Seu tempo de conexão foi expirado.', 'Erro');
                    }
                    , 1000);
                    location.reload();
                    this._authService.doLogout();
                    errorMsg = 'Seu tempo de conexão foi expirado';
                    break;
                case 400:
                    errorMsg = 'Erro 400';
                    
                    if (err.error as string){
                        errorMsg = err.error;
                    }
                    else if( err.error.error = "invalid_client"){
                        errorMsg = 'Usuário ou senha inválido';
                    }                    
                    break;
                    case 503:                        
                        this._toastr.error("Não foi possível estabelecer comunicação com o Serviço de relatório Crystal Reports (CrystalReports.exe).", 
                        "Relatório");                   
                        break;
                case 504:
                case 524:
                    errorMsg = "O servidor demorou mais que o esperado para responder. A operação pode ter sido concluída — verifique antes de tentar novamente.";
                    break;
                case 408:
                    errorMsg = "O tempo de resposta da requisição se esgotou. Verifique sua conexão e tente novamente.";
                    break;
                case 0:
                    errorMsg = "Não foi possível concluir a comunicação com o servidor. Verifique sua conexão ou tente novamente em instantes.";
                    break;
                default:
                    if (err?.error?.value != undefined){
                        return throwError(err);
                    }
                    errorMsg = err?.error?.message || err?.statusText;
                    break;
            } 
            return throwError(errorMsg);
        }))
    }
}